import { user } from './reducers';
export default user;
